export default "__VITE_ASSET__BEvv8lsV__"